import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import Pulse from "../Loader/Pulse";
import { Cross, ArchiveBook } from "../CustomComponents/SwiftIcon/Icons";
import { GetCookie } from "../../exports/CookieManagement";
import { COLOR_VARS } from "../../exports/ColorVars";
import { getDeviceSize } from "../../exports/InteractiveUtils";

const REQUEST_BASE_URL = process.env.REACT_APP_REQUEST_BASE_URL;

function Notifications({ close }) {
  const [isActive, setIsActive] = useState(false);
  const DEVICE_SIZE = getDeviceSize();
  async function GetNotifications() {
    const account_token = GetCookie("token");

    const response = await fetch(
      `${REQUEST_BASE_URL}/clientinfo/notifications?token=${account_token}`,
    );
    const data = await response.json();
    if (data.error) {
      return false;
    }

    return data;
  }

  const { data: notifications, isLoading } = useQuery(
    ["notifications"],
    GetNotifications,
  );

  useEffect(() => {
    setIsActive(true);
  }, []);

  return (
    <div className={`notifications-popup ${isActive ? "active" : ""}`}>
      {isLoading && (
        <>
          <div className="notifications-popup-loader">
            <Pulse />
          </div>
        </>
      )}
      <div className="notifications-header">
        <p className="notifications-title">Notifications</p>
        <div className="notifications-close" onClick={close}>
          <Cross color={COLOR_VARS["SWIFT_COLOR4"]} size={26} />
        </div>
      </div>
      <div className="notifications-body">
        {!isLoading && (
          <>
            {notifications.length === 0 ? (
              <>
                <div className="notifications-empty">
                  <ArchiveBook color={COLOR_VARS["SWIFT_COLOR4"]} size={40} />
                  <p>No notifications to display</p>
                </div>
              </>
            ) : (
              <>
                <div className="notifications-list">
                  {notifications.map((n, index) => {
                    return (
                      <NotificationRow
                        key={index}
                        notification={n}
                        DEVICE_SIZE={DEVICE_SIZE}
                      />
                    );
                  })}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

function NotificationRow({ notification, DEVICE_SIZE }) {
  return (
    <>
      <div className="notification-row">
        {DEVICE_SIZE === "S" ? (
          <>
            <p className="time">
              {moment(notification.timestamp).format("DD-MMM-YYYY HH:mm")}
            </p>
            <div className="content-wrapper">
              <p className="subject">{notification.heading}</p>
              <div
                className="body"
                dangerouslySetInnerHTML={{ __html: notification.body }}
              />
            </div>
          </>
        ) : (
          <>
            <div className="content-wrapper">
              <p className="subject">{notification.heading}</p>
              <div
                className="body"
                dangerouslySetInnerHTML={{ __html: notification.body }}
              />
            </div>
            <p className="time">
              {moment(notification.timestamp).format("DD-MMM-YYYY HH:mm A")}
            </p>
          </>
        )}
      </div>
    </>
  );
}

export default Notifications;
